function addIsoDays(isoDate, days) {
  const [year, month, day] = isoDate.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

function formationDateIsCurrent(documentDate, todayIso) {
  if (!documentDate || !/^\d{4}-\d{2}-\d{2}$/.test(documentDate)) return false;
  if (!todayIso || !/^\d{4}-\d{2}-\d{2}$/.test(todayIso)) return false;
  return documentDate >= todayIso;
}

function formationDateInWindow(documentDate, todayIso) {
  if (!formationDateIsCurrent(documentDate, todayIso)) return false;
  return documentDate <= addIsoDays(todayIso, 7);
}

function formationFieldDate(documentDate, todayIso) {
  if (!formationDateInWindow(documentDate, todayIso)) return '';
  return documentDate;
}

module.exports = formationDateIsCurrent;
module.exports.formationDateInWindow = formationDateInWindow;
module.exports.formationFieldDate = formationFieldDate;
